import React from 'react'
import term from '../../../assets/term.svg'
export default function Condition() {
  return (
    <div>
      <div className="container  row">
        <div className="col-lg-5 mt-10 mx-auto flex-col flex-wrap">
          <div className="my-3 ">
            <h2 className="text-2xl head text-orange-500 font-bold d-inline">
              Conditions d'utilisations.{' '}
            </h2>
            <p className="text-gray text-sm">
              Havoo est une plateforme de mise en relation des demandeurs de
              services avec ceux qui en proposent ,par le billet de cet
              application web ,nous vous offrons le meilleur service possible en
              terme d'efficacite et autres...
            </p>
          </div>
          <div className="">
            <div className="text-red-500 head text-2xl">
              <h2>Services</h2>
            </div>
            <h3 className="text-black mt-2 mb-1 text-xs head  text-start">1) Profile</h3>
            <p>
              Pour commander une prestation de service au pres de l'entite Havoo
              vous devez prealablement creer un profile personel
            </p>

            <h3 className="text-black my-2 mb-0 text-xs head text-start">2) Age</h3>
            <p>
              Pour commander une prestation de service au pres de l'entite Havoo
              vous devez avoir l'age legal en vigueur dans votre pays ,royaume
              ou etat...
            </p>
            <h3 className="text-black mt-2 text-xs head text-start">3) Informations</h3>
            <p>
              Pour utiliser nos service vous devez obligatoirement mettre les
              Informations qui figurent dans vos douments officiels tels la
              CNI,PASSEPORT et autre pieces officielles
            </p>
          </div>

          <div className="text-gray-500 my-2">
            <div className="text-xl  head text-red-500">
              <h2>Information que nous receuillons</h2>
            </div>

            <p>
              Vous devez nous fournir vos Informations personnelles pour
              permettre a nos algorithmes de vous fournir au mieux le service
              que nous proposons
            </p>
          </div>

          <div className="text-gray-500 my-2">
          <div className="text-xl  head text-red-500">
              <h2>L'inscription</h2>
            </div>
            <p>
              L'inscription vous permet d'avoir un compte client chez nous,pour
              se faire vous avez un formulaire qui vous demande certaines
              Informations necessaires pour vous identifier
            </p>
          </div>

          <div className="text-gray-500 my-2">
          <div className="text-xl  head text-red-500">
              <h2>Annulation d'une demande</h2>
            </div>
            <p>
              En cas d'annulation d'une commande ,vous ete tenude payer des
              frais de traitement quelque soit la nature de la commande qui
              s'eleve a 1000 cfa .
            </p>
          </div>
          <div className="text-gray-500 my-2">
          <div className="text-xl  head text-red-500">
              <h2>Urgence</h2>
            </div>
            <p>
              Les utilisateurs qui ont une Urgence sur le service demande
              doivent obligatoirement passer un appel a la centrale via les
              moyens de communications mis a leur disposition,il est a noter que
              l'utilisation de ce service exige le paiement de frais
              supplementaire . <br /> L'entreprise ne sera pas tenu pour
              responable si vous utilisez le service <b>Urgence</b> par les
              numeros qui ne figurent pas sur le site
            </p>
          </div>

          <div className="text-gray-500 my-2">
          <div className="text-xl  head text-red-500">
              <h2>Passer la commande</h2>
            </div>
            <p>
              Les demandes de services se font obligatoirement 24h avant la date
              prevue sur notre plateforme web uniquement,sans quoi vous ne serez
              pas pris en charge,sauf en cas d'urgence.
            </p>
          </div>

          <div className="text-gray-500 my-2">
          <div className="text-xl  head text-red-500">
              <h2>Service de Nuit (Apres 18h) </h2>
            </div>
            <p>
              Nos prestations ne sont pas prevues pour etre execute la nuit ,
              sauf si vous utilisez notre service urgence.
            </p>
          </div>

          <div className="text-gray-500 my-2">
          <div className="text-xl  head text-red-500">
              <h2>Execution de la prestation</h2>
            </div>
            <p>
              Quand un prestataire arrive assurez vous qu'il a ete envoye par
              HAVOO ,en regardant le CODID fournit lors de la creation de la
              commande et disponible dans votre pofile a la rubrique "Services".
              <br />A la fin de la prestation ,verifiez que rien n'a ete derobe
              et que votre local est bel et bien pareil .
            </p>
          </div>
        </div>
        
      </div>
    </div>
  )
}
